export default __webpack_public_path__ + "static/media/Support.3dd59a7c8e15028addeeab7c218fb35a.svg";